import './Contact.css'
import { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import { useTranslation } from 'react-i18next';
import { Toaster, toast } from 'sonner';

function Contact() {
    const form = useRef();
    const [formData, setFormData] = useState({
        user_name: '',
        user_email: '',
        message: '',
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };


    const sendEmail = (e) => {
        e.preventDefault();
        if (validateForm(formData.user_name, formData.user_email, formData.message)){
            emailjs
            .sendForm(process.env.REACT_APP_SERVICE_KEY, process.env.REACT_APP_TEMPLATE_ID, form.current, {
                publicKey: process.env.REACT_APP_PUBLIC_KEY,
            })
            .then(
                () => {
                    console.log('SUCCESS!');
                    toast.success("Email sent")
                },
                (error) => {
                    console.log('FAILED...', error.text);
                    toast.error("Email has not been sent")
                },
            );
        }else{
            toast.error("Incorrectly typed form")
        }
    };

    const validateForm = (name, email, message) => {
        if (name.length <= 0 || email.length <= 0 || message.length <= 0) {
            return false
        } else {
            return true
        }
    }

    const { t } = useTranslation()

    return (
        <>
            <section className="container-lg p-0 d-flex justify-content-between align-items-center">
                <hr className='heading-hr heading' />
                <h2 className='heading'>{t("contact.title")}</h2>
            </section>

            <section className="container-lg mb-5 contact-info" id='section_5'>
                <div className="row mt-5">
                    <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 d-flex flex-column justify-content-center align-items-center">
                        <h3 className='p-0 m-0'>{t("contact.title")}:</h3>
                        <p className='p-0 m-0'>+48 731-196-509</p>
                        <p className='p-0 m-0' >Piotr Kubicki</p>
                    </div>

                    <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 d-flex flex-column justify-content-center align-items-center">
                        <h3 className='p-0 m-0'>{t("contact.adres")}:</h3>
                        <p className='p-0 m-0'>Kołomań 75</p>
                        <p className='p-0 m-0'>Zagnańsk, 26-050</p>
                    </div>
                </div>
            </section>
            <section className="container-lg mb-3 contact-panel">
                <div className="row h-100">
                    <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 d-flex flex-column justify-content-center align-items-center">
                        <p className='p-0 m-0'>{t("contact.text1")}</p>
                        <p className='p-0 m-0'>{t("contact.text2")}</p>
                        <p className='p-0 m-0 mt-2' id='text-shine'>kamtechnet@gmail.com</p>
                    </div>
                    <div className="col-xl-6 col-lg-6 col-md-12 col-sm-1">
                        <form className='h-100 d-flex flex-column' ref={form} onSubmit={sendEmail}>
                            <div className="mb-3">
                                <input type='text' required className="w-100" id="topic" aria-describedby="emailHelp" placeholder={t("contact.placeholder1")} name='user_name' onChange={handleChange} />
                            </div>
                            <div className="mb-3">
                                <input type='email' required className="w-100" id="email" aria-describedby="emailHelp" placeholder={t("contact.placeholder2")} name='user_email' onChange={handleChange}/>
                            </div>
                            <div className="mb-3 flex-fill">
                                <textarea required className="w-100 h-100" id="response" rows="4" placeholder={t("contact.placeholder3")} name='message' onChange={handleChange}/>
                            </div>
                            <button type="submit" className="w-100">{t("contact.button")}</button>
                        </form>
                    </div>
                </div>
                <Toaster position="bottom-center" richColors />
            </section>

        </>
    )
}

export default Contact